import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaInput from './TextareaInput';
import Stream from '../../Content/Stream';

export default class StreamInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalid: false,
      showIframe: false,
      iframeCode: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.checkIfValid(nextProps.value);
  }

  checkIfValid = (embedCode) => {
    const acceptedTypes = ['youtube', 'vimeo', 'soundcloud'];
    if (embedCode.includes('iframe') && acceptedTypes.some(acceptedType => embedCode.includes(acceptedType))) {
      this.setState({ invalid: false, showIframe: true, iframeCode: embedCode });
    } else {
      this.setState({ invalid: true, showIframe: false });
    }
  }

  render() {
    const { name, value } = this.props;
    const { invalid, showIframe, iframeCode } = this.state;

    let label;
    if (invalid === true) {
      label = 'The code entered does not appear to be a valid Youtube, Vimeo or Soundcloud embed code';
    } else {
      label = 'Paste your Youtube, Vimeo or Soundcloud embed code in the field below';
    }

    return (
      <div>
        <TextareaInput
          label={label}
          name={name}
          value={value}
          placeholder="Paste embed code here"
          onChange={e => this.props.onChange(e)}
          autoResize
        />

        {showIframe &&
          <div className="stream-preview">
            <Stream iframe={iframeCode} />
          </div>
        }
      </div>
    );
  }
}

StreamInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/StreamInput.js